<template>

    <v-card
        class="mx-auto mr-2 ml-2 mt-2 mb-2"
        max-width="320px"
        
    >
        <v-img
            :src= src+image.imageName
            width="320px"
            height ="212px"
            contain
        >
    </v-img>
        <v-card-title>
            {{image.menuName}}  
        </v-card-title>
            <div>   
        <v-row>

        <div class="ml-4">Price: {{image.price}}</div>
            <v-spacer></v-spacer>
        <v-btn
            icon
            @click="show = !show"   
        >   
            <v-icon color="primary" class="mr-4">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
        </v-row>
        </div>
    <v-expand-transition>
        <div v-show="show">
            <v-card-text>
                {{image.description}}
            </v-card-text>        
        </div>
    </v-expand-transition>
    </v-card>
</template>

<script>
export default {
    props: ["image"],
    data() {
        return {
            show: false
        }
    },
    computed: {
        src: function() {
            if(process.env.NODE_ENV === 'production') {
                return "/api/images/image?filename="
            } else {
                return "http://localhost:5000/api/images/image?filename="
            }
        }
    },
}
</script>

<style>
.product-box{

    margin-top: 100px;
    margin-right: 20px;
    margin-left: 10px;

  }

  .product-box-mobile {
    width: 40px;
    height: 60px;
   
  }
  .product-title{
 
    font-size:105px;
    color: grey;
     
  }

  .product-title-mobile{
    
    font-size: 12px;
    color:black;
    
  }
  .menu-name {  
    color: gray;  
    font-size: 22px;
    font-style: italic;
  }
</style>